import { createApi } from '@reduxjs/toolkit/query/react';
import { baseApiQuery } from '../basequery';
import { GetLegalWaiverByIdResponse } from '../../types/legalWaiver';
import { formsApi } from './forms.api';
import { qualityAndRiskApi } from './qualityandrisk.api';

export const legalWaiverApi = createApi({
  reducerPath: 'legalWaiverApi',
  baseQuery: baseApiQuery,
  tagTypes: ['LegalWaiverID'],
  endpoints: (builder) => ({
    /**
     * Fetches legal waiver section data for a specific form by ID
     * @param id - The form ID
     */
    getLegalWaiverById: builder.query<GetLegalWaiverByIdResponse, { id: number }>({
      query: ({ id }) => ({ url: `/legal-waiver/${id}`, method: 'GET' }),
      providesTags: (_result, _error, { id }) => [{ type: 'LegalWaiverID', id }],
    }),

    /**
     * Submits the legal waiver section — upserts LegalWaiverSection row and
     * updates Form status to Approved or Rejected.
     */
    submitLegalWaiver: builder.mutation<
      {
        data: {
          id: number;
          status: string;
          emailNotificationSent?: boolean;
        };
      },
      {
        id: number;
        data: {
          isClientRefusedToSignWaiver: boolean;
          waiverRefusalDescription?: string | null;
          waiverFileAttachmentId?: number | null;
        };
      }
    >({
      query: ({ id, data }) => ({
        url: `/legal-waiver/${id}/submit`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'LegalWaiverID', id }],
      onQueryStarted: async ({ id }, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(formsApi.util.invalidateTags([{ type: 'MyFormsID', id }]));
          dispatch(qualityAndRiskApi.util.invalidateTags([{ type: 'QualityAndRiskID', id }]));
        } catch {
          // swallow to avoid unhandled rejection
        }
      },
    }),
  }),
});

export const {
  useGetLegalWaiverByIdQuery,
  useLazyGetLegalWaiverByIdQuery,
  useSubmitLegalWaiverMutation,
} = legalWaiverApi;
